
import Vue from "vue";
export default Vue.extend({
	props: {
		to: String,
		disabled: Boolean
	},
	computed: {
		tabindex():number{
			if (this.disabled){
				return -1;
			}
			return 0;
		}
	},
	methods: {
		onClick(event:Event) {
			if (this.disabled){
				return;
			}
			event.preventDefault();
			if (this.to){
				this.$router.push(this.to);
			}
			this.$emit("click", event);
		},
		onFocus(event:FocusEvent){
			if (this.disabled){
				(event.target as HTMLAnchorElement).blur();
			}
		}
	}
});
